import { Outlet, useLocation } from "react-router-dom";

import { useStoreMe } from "@/hooks/useStoreMe";
import { cn } from "@/lib/utils";

import styles from "./AppLayout.module.scss";
import { BottomNav } from "./BottomNav";
import { Header } from "./Header";

// List of routes that should be full width
const FULL_WIDTH_ROUTES = ["/dashboard", "/transactions"];

export const AppLayout = () => {
  // Dùng useStoreMe thay vì getCookie để check auth (HttpOnly)
  const { data: storeData } = useStoreMe();
  const isAuthenticated = !!storeData;
  const location = useLocation();

  // Check if current path starts with any of the full-width routes
  const isFullWidth = FULL_WIDTH_ROUTES.some((route) =>
    location.pathname.startsWith(route),
  );

  // Common container class to sync Header and Content
  const containerClass = isFullWidth
    ? "max-w-full px-4 md:px-10"
    : "max-w-[830px] mx-auto w-full px-4 md:px-10";

  return (
    <div className={cn(styles["app-layout"], "pt-4 md:pt-10")}>
      {/* Header */}
      <Header containerClass={containerClass} />

      {/* Main content area */}
      <main
        className={cn(
          styles["main-content"],
          containerClass,
          !isAuthenticated && "pb-0", // Remove bottom padding if no BottomNav
        )}
        role="main"
      >
        <Outlet />
      </main>

      {/* Bottom navigation - Only show when authenticated */}
      {isAuthenticated && <BottomNav />}
    </div>
  );
};
